import React from 'react';
import { Divider } from '@mui/material'; 
import { useTheme,Theme } from '@mui/material/styles';
import { EditorStateContext } from '@/rich-text/editor';
import { SizeControls } from '@/rich-text/controls/size-controls';
import { AlignmentControls } from '@/rich-text/controls/alignment-controls';
import { FormatControls } from '@/rich-text/controls/format-controls';
import { LinkControls } from '@/rich-text/controls/link-controls';

const useStyles =  (theme:Theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100]
  },
  divider: {
      margin: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  }
});

export const Toolbar = () => {

  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <EditorStateContext.Consumer>
      {(provided) => (
        <div className={classes.toolbar} onMouseDownCapture={(e) => e.preventDefault()}>
            <SizeControls {...provided} />
            <Divider flexItem orientation="vertical" className={classes.divider} />
            <AlignmentControls {...provided} />
            <Divider flexItem orientation="vertical" className={classes.divider} />
            <FormatControls {...provided} />
            <LinkControls {...provided} />
        </div>
      )}
    </EditorStateContext.Consumer>
  );
};